var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ticket-cggl',{attrs:{"method-name":'getAllOrderLists',"show-status-tab":true,"show-header-type":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }